import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { CustomMetaTitle, LinkReturnToMain, Loader } from 'Components';
import { Title } from './Title';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { Avatar, Link, Stack, Typography } from '@mui/material';
import { EquipmentOrderStatus } from '../Equipment/EquipmentMain/OrderStatusDialog/EquipmentOrderStatus';
import { EquipmentList } from 'Modules/Equipment/EquipmentMain/OrderStatusDialog/EquipmentList';
import {
  ConsEquipOrderIdentifierType,
  IEquipmentPrevOrder,
  getEquipmentByID,
} from 'API';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { ContactUsHeadphones } from 'Images';

// import { useContext } from 'react';
// import { EquipmentContext } from 'Context';
// import { useParams } from 'react-router-dom';

export const EquipmentOrderInfo = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [equipmentOrderInfo, setEquipmentOrderInfo] =
    useState<IEquipmentPrevOrder | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const params = useParams();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const initEquipmentOrderInfo = useCallback(async () => {
    const equipType =
      params.id && params.id?.length < 12
        ? ConsEquipOrderIdentifierType.IntReqNumber
        : ConsEquipOrderIdentifierType.ShemeshRequestNumber;
    const equipmentOrderInfo = await getEquipmentByID(params.id, equipType);

    if (equipmentOrderInfo) {
      setIsLoading(false);
      setEquipmentOrderInfo(equipmentOrderInfo);
    }
  }, [params.id]);

  useEffect(() => {
    initEquipmentOrderInfo();
    window.scrollTo(0, 0);
  }, [initEquipmentOrderInfo, imposterId]);
  return (
    <>
      <CustomMetaTitle title={dictionary.title} />
      <LinkReturnToMain
        link='/Equipment'
        label={dictionary.breadcrumbs}
        internal
      />

      {isLoading ? (
        <Loader />
      ) : equipmentOrderInfo ? (
        <Stack
          gap={isDesktop ? '28px' : '32px'}
          maxWidth={isDesktop ? '960px' : 'initial'}
          mt={isDesktop ? '30px' : '24px'}
        >
          <Title
            order={equipmentOrderInfo}
            requestNumber={equipmentOrderInfo.requestNumber || undefined}
          />
          <Stack>
            <EquipmentOrderStatus order={equipmentOrderInfo} />
            <EquipmentList orderItems={equipmentOrderInfo.orderItems} />
            {equipmentOrderInfo.note && (
              <>
                <Typography
                  sx={{
                    margin: '70px 0 15px 0',
                    fontSize: '18px',
                    fontWeight: 'bold',
                  }}
                >
                  {dictionary.orderNotes}
                </Typography>
                <Typography variant='body6'>
                  {equipmentOrderInfo.note}
                </Typography>
              </>
            )}

            <Stack
              sx={{
                borderRadius: '16px',
                border: '1px solid',
                borderColor: 'primary.shade_200',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                p: '16px',
                bgcolor: 'white',
                gap: 1,
                mt: 3,
              }}
            >
              <Avatar
                src={ContactUsHeadphones}
                sx={{ width: '50px', height: '50px', mr: 1, mb: 1 }}
                alt=''
              />
              <Typography display={'inline'}>
                {dictionary.contactComponent[0]}
              </Typography>
              <Typography variant='body3' display={'inline'}>
                {dictionary.contactComponent[1]}
              </Typography>
              <Link
                variant='body2'
                underline='none'
                href={`tel:${dictionary.contactComponent[2]}`}
              >
                <Typography variant='body3' display={'inline'}>
                  {
                    dictionary
                      .forQuestionsContactTheHotlineOnTheWebsiteOrByPhone[3]
                  }
                </Typography>
              </Link>
            </Stack>
          </Stack>
        </Stack>
      ) : (
        <></>
      )}
    </>
  );
};
